    /**
 * Product list item: add-to-cart and size selection.
 * Loaded globally so it works on collection, home featured, and product recommendations
 * (recommendations are injected via AJAX and scripts in that HTML do not run).
 */
(function () {
  function init() {
    if (window.__productListItemAddToCartInit) return;
    window.__productListItemAddToCartInit = true;

    // Keep header cart count in sync even when third-party apps
    // update the cart via /cart/change.js (e.g. cart drawer/upsell apps).
    if (!window.__animusCartFetchPatched && window.fetch) {
      window.__animusCartFetchPatched = true;
      var _originalFetch = window.fetch;

      function syncHeaderCartCount(cart) {
        if (!cart || typeof cart.item_count !== "number") return;

        document.querySelectorAll(".cart-item-count").forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "inline-block" : "none";
        });

        document.querySelectorAll(".header-tools-cart").forEach(function (icon) {
          icon.classList.toggle("cart-has-content", cart.item_count > 0);
        });
      }

      window.fetch = function () {
        var fetchArgs = arguments;
        return _originalFetch.apply(window, fetchArgs).then(function (response) {
          try {
            var url = fetchArgs && fetchArgs[0] ? fetchArgs[0].toString() : "";
            var isCartMutation = url.indexOf("/cart/change.js") !== -1 || url.indexOf("/cart/add.js") !== -1 || url.indexOf("/cart/update.js") !== -1;

            if (response && response.ok && isCartMutation) {
              response.clone().json().then(function (data) {
                if (data && typeof data.item_count === "number") {
                  // /cart/change.js returns the cart object
                  syncHeaderCartCount(data);
                } else if (url.indexOf("/cart/add.js") !== -1) {
                  // /cart/add.js returns a line item, so fetch /cart.js for count
                  _originalFetch.call(window, "/cart.js").then(function (r) { return r.json(); }).then(syncHeaderCartCount);
                }
              }).catch(function () {
                // ignore non-JSON responses
              });
            }
          } catch (e) {
            // ignore
          }

          return response;
        });
      };
    }

    var formFlags = new WeakMap();

    function initFormDefaultVariant(form) {
      if (form.dataset.initDone === "true") return;
      var sizeButtons = form.querySelectorAll(".size-btn:not([disabled])");
      var selectedVariantInput = form.querySelector(".selected-variant");
      if (sizeButtons.length > 0) {
        selectedVariantInput.value = sizeButtons[0].value;
        sizeButtons[0].classList.add("active");
      } else if (selectedVariantInput && form.dataset.firstVariantId) {
        selectedVariantInput.value = form.dataset.firstVariantId;
      }
      form.dataset.initDone = "true";
    }

    document.querySelectorAll(".add-to-cart-form").forEach(function (form) {
      initFormDefaultVariant(form);
    });

    document.addEventListener("mouseenter", function (e) {
      var card = e.target.closest && e.target.closest(".product-list-item");
      if (card) card.classList.add("product-list-item--card-hovered");
    }, true);
    document.addEventListener("mouseleave", function (e) {
      var card = e.target.closest && e.target.closest(".product-list-item");
      if (card) card.classList.remove("product-list-item--card-hovered");
    }, true);

    document.addEventListener("click", function (e) {
      var target = e.target;
      var form = target.closest && target.closest(".add-to-cart-form");
      if (!form) {
        if (target.classList && target.classList.contains("add-to-cart-btn-overlay")) {
          var productListItem = target.closest && target.closest(".product-list-item");
          form = productListItem && productListItem.querySelector(".add-to-cart-form");
        }
      }
      if (!form) return;

      initFormDefaultVariant(form);

      var sizeButtons = form.querySelectorAll(".size-btn");
      var selectedVariantInput = form.querySelector(".selected-variant");

      if (target.classList && target.classList.contains("size-btn") && !target.disabled) {
        e.preventDefault();
        selectedVariantInput.value = target.value;
        sizeButtons.forEach(function (btn) { btn.classList.remove("active"); });
        target.classList.add("active");
        return;
      }

      if (target.classList && target.classList.contains("add-to-cart-btn-overlay")) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = selectedVariantInput.value || (form.dataset.firstVariantId || null);
        if (!variantId) {
          showToast("Please select a size.");
          return;
        }
        if (formFlags.get(form)) return;
        formFlags.set(form, true);
        addOrIncreaseInCart(variantId).then(function () {
          // showToast("Product added to cart!");
          openCartDrawer();
          formFlags.set(form, false);
        }).catch(function (err) {
          showErrorToast(err && err.message ? err.message : "Something went wrong. Please try again.");
          formFlags.set(form, false);
        });
      }
    }, true);

    var closeToastButton = document.querySelector(".close-toast");
    if (closeToastButton) {
      closeToastButton.addEventListener("click", function () {
        var toast = document.querySelector("#toast-notification");
        if (toast) toast.classList.remove("show");
      });
    }

    document.querySelectorAll(".remove-from-cart").forEach(function (button) {
      button.addEventListener("click", async function () {
        var variantId = button.getAttribute("data-variant-id");
        await removeFromCart(variantId);
        // showToast("Product removed from cart!");
        updateCartUI();
      });
    });

    function addOrIncreaseInCart(variantId) {
      var errMessage = "Something went wrong. Please try again.";
      return fetch("/cart.js")
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var existing = cart.items.find(function (item) { return item.variant_id === parseInt(variantId, 10); });
          if (existing) {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: existing.key, quantity: existing.quantity + 1 }),
            });
          }
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          });
        })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) {
              errMessage = data.description || data.message || errMessage;
              throw new Error(errMessage);
            }
            updateCartUI();
          });
        })
        .catch(function (e) {
          if (e && e.message) errMessage = e.message;
          throw new Error(errMessage);
        });
    }

    function removeFromCart(lineItemKey) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
      }).then(function (response) {
        if (!response.ok) throw new Error("Remove from cart failed");
        return response.json();
      }).then(function () {
        updateCartUI();
      }).catch(function (error) {
        console.error("Error removing item from cart:", error);
      });
    }

    function updateCartUI() {
      fetch("/cart.js")
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var itemCount = cart.item_count;
          var cartItemCount = document.querySelector(".cart-item-count");
          if (cartItemCount) {
            cartItemCount.textContent = itemCount;
            cartItemCount.style.display = itemCount > 0 ? "inline-block" : "none";
          }
        })
        .catch(function (error) { return console.error("Error updating cart UI:", error); });
    }

    function openCartDrawer() {
      document.dispatchEvent(new CustomEvent("cart:updated"));
      document.dispatchEvent(new CustomEvent("openCartDrawer"));
      var cartIcon = document.querySelector(".header-tools-cart");
      if (cartIcon) cartIcon.click();
    }

    function showToast(message) {
      var toastNotification = document.querySelector("#toast-notification");
      var toastMessage = toastNotification && toastNotification.querySelector(".toast-message");
      if (toastNotification && toastMessage) {
        toastNotification.classList.remove("toast-error");
        toastMessage.textContent = message;
        toastNotification.classList.add("show");
        setTimeout(function () { toastNotification.classList.remove("show"); }, 3000);
      }
    }

    function showErrorToast(message) {
      var toastNotification = document.querySelector("#toast-notification");
      var toastMessage = toastNotification && toastNotification.querySelector(".toast-message");
      if (toastNotification && toastMessage) {
        toastNotification.classList.add("toast-error");
        toastMessage.textContent = message;
        toastNotification.classList.add("show");
        setTimeout(function () {
          toastNotification.classList.remove("show");
          toastNotification.classList.remove("toast-error");
        }, 4000);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
